// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import RgaWipContainer from './state-connector';

const RgaWip = props =>
    props.children || <RgaWipContainer {...props}/>;

RgaWip.propTypes = {
    children: PropTypes.node
};

export default RgaWip;



// WEBPACK FOOTER //
// ./src/rga/search/index.js